import React from "react";
import "../Styles/home.css";
import Homeslider from "../Components/Homeslider";
import "../Styles/home.css";
import card1 from "../Images/STOCKOFFICER.jpg";
import card2 from "../Images/STOCKOFFICER.jpg";
import card3 from "../Images/STOCKOFFICER.jpg";

export default function Home() {
  return (
    <React.Fragment>
      <>
        <div>
          <div className="grow shrink-0">
            <Homeslider />
            <section className="row container col-md-10 wrapper !bg-[#ffffff]">
              <div className="col-md-10  py-[4.5rem] xl:!py-22 lg:!py-22 md:!py-22">
                <div className="col-md-12 flex flex-wrap mx-[-15px] xl:mx-[-35px] lg:mx-[-20px] mt-[-50px] items-center">
                  <div className="col-md-12 xl:w-12/12 lg:w-12/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] px-[15px] mt-[50px]">
                    <h2 className="col-md-12 !text-[.75rem] uppercase text-line relative align-top pl-[1.4rem] inline-flex tracking-[0.02rem] leading-[1.35] before:content-[''] before:absolute before:inline-block before:translate-y-[-60%] before:w-3 before:h-[0.05rem] before:left-0 before:top-2/4 before:bg-[#3f78e0] text-[#3f78e0] !mb-3 typewriter">
                      Think unique and be innovative. Make a difference With
                      ECHS CELL
                    </h2>
                    <h3 className="col-md-12 text-[calc(1.285rem_+_0.42vw)] font-bold xl:text-[1.6rem] !leading-[1.3] mb-5">
                      Collaboration for Impact: A Project in Action
                    </h3>
                    <p className=" col-md-12">
                      Retired Armed Forces personnel till 2002 could avail
                      medical facilities only for specific high cost
                      surgery/treatment for a limited number of diseases covered
                      under the Army Group Insurance(Medical Branch Scheme)
                      (AGI(MBS)) and Armed Forces Group Insurance
                      Scheme(Management Information System) (AFGIS (MIS))
                      schemes. These medicare schemes could provide some relief
                      to the ESM, but it was not a comprehensive scheme as
                      compared to and available for other Central Government
                      Employees. Therefore, the requirement was felt of
                      establishing a medicare system which could provide quality
                      medicare to the retirees of the Armed Forces. Based on
                      this noble aim, and after detailed deliberations, a
                      comprehensive scheme has taken shape as ECHS, authorised
                      vide Government of India, Ministry of Defence letter No
                      22(i) 01/US/D(Res) dated 30 Dec 2002. The ECHS was
                      launched with effect from 01 Apr 2003. With the advent of
                      this scheme. Ex-servicemen pensioners and their dependants
                      who were only entitled for treatment in service hospital
                      are now authorised treatment, not only in service
                      hospitals, but also in those civil/private hospitals which
                      are specifically empanelled with the ECHS.
                    </p>
                    <a
                      href="/about"
                      className="btn btn-primary text-white !bg-[#3f78e0] border-[#3f78e0] hover:text-white hover:bg-[#3f78e0] hover:border-[#3f78e0] focus:shadow-[rgba(92,140,229,1)] active:text-white active:bg-[#3f78e0] active:border-[#3f78e0] disabled:text-white disabled:bg-[#3f78e0] disabled:border-[#3f78e0] !rounded-[50rem] mt-3 hover:translate-y-[-0.15rem] hover:shadow-[0_0.25rem_0.75rem_rgba(30,34,40,0.15)]"
                    >
                      More About Us
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className="">
          <section className="bg-1">
            <div className="container-fluid pt-20 !pb-[4.5rem] xl:!pb-24 lg:!pb-24 md:!pb-24">
              <div className="flex flex-wrap mx-[-15px] !text-center">
                <div className="lg:w-10/12 xl:w-9/12 xxl:w-8/12 flex-[0_0_auto] px-[15px] max-w-full !mx-auto !relative">
                  <img
                    src="assets/img/svg/doodle4.svg"
                    className="h-8 absolute hidden xl:block lg:block"
                    style={{ top: "6%", right: "2%" }}
                    alt="image"
                  />{" "}
                  <h2 className=" text-[0.8rem] !leading-[1.35] tracking-[0.02rem] uppercase text-[#aab0bc] !mb-3">
                    Software Features
                  </h2>
                  <h3 className="xl:text-[2rem] text-[calc(1.325rem_+_0.9vw)] font-semibold !leading-[1.2] mb-12 lg:!px-5 xl:!px-0 xxl:!px-6">
                    E-MAS makes your spending{" "}
                    <span className="text-gradient gradient-7">
                      stress-free
                    </span>{" "}
                    for you to have the perfect control.
                  </h3>
                </div>
              </div>
              <marquee scrollamount={8}>
                <div className="flex !flex-nowrap mx-[-15px] xl:mx-0 lg:mx-0 md:mx-0 !text-center">
                  <div className="w-[10%] flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full">
                    <div className="svg-bg svg-bg-lg !bg-[#fef3e4] !rounded-[0.8rem] mb-4">
                      {" "}
                      <img
                        src="assets/img/icons/solid/cloud-network-2.svg"
                        className="svg-inject icon-svg solid text-[#343f52] text-navy"
                        alt="image"
                      />
                    </div>
                    <h4 className="text-[1rem]">
                      Streamlined Recruitment Process
                    </h4>
                  </div>
                  <div className="w-[10%] flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full">
                    <div className="svg-bg svg-bg-lg bg-[#e1f6f0] !rounded-[0.8rem] mb-4">
                      {" "}
                      <img
                        src="assets/img/icons/solid/touchscreen.svg"
                        className="svg-inject icon-svg solid text-[#343f52] text-navy"
                        alt="image"
                      />{" "}
                    </div>
                    <h4 className="text-[1rem]">
                      Comprehensive Monthly Accounting{" "}
                    </h4>
                  </div>
                  <div className="w-[10%] flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full">
                    <div className="svg-bg svg-bg-lg bg-[#e9eaf8] !rounded-[0.8rem] mb-4">
                      {" "}
                      <img
                        src="assets/img/icons/solid/lock.svg"
                        className="svg-inject icon-svg solid text-[#343f52] text-navy"
                        alt="image"
                      />{" "}
                    </div>
                    <h4 className="text-[1rem]">
                      Daily DASR (Daily Average Sick Report) Insights
                    </h4>
                  </div>
                  <div className="w-[10%] flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full">
                    <div className="svg-bg svg-bg-lg bg-[#f8e7ec] !rounded-[0.8rem] mb-4">
                      {" "}
                      <img
                        src="assets/img/icons/solid/rocket.svg"
                        className="svg-inject icon-svg solid text-[#343f52] text-navy"
                        alt="image"
                      />{" "}
                    </div>
                    <h4 className="text-[1rem]">
                      Real-Time Referral Status Tracking
                    </h4>
                  </div>
                  <div className="w-[10%] flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full">
                    <div className="svg-bg svg-bg-lg bg-[#f0eaf6] !rounded-[0.8rem] mb-4">
                      {" "}
                      <img
                        src="assets/img/icons/solid/bar-chart.svg"
                        className="svg-inject icon-svg solid text-[#343f52] text-navy"
                        alt="image"
                      />{" "}
                    </div>
                    <h4 className="text-[1rem]">
                      Effortless Expense Management
                    </h4>
                  </div>
                  <div className="w-[10%] flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full">
                    <div className="svg-bg svg-bg-lg bg-[#e0e9fa] !rounded-[0.8rem] mb-4">
                      {" "}
                      <img
                        src="assets/img/icons/solid/controls.svg"
                        className="svg-inject icon-svg solid text-[#343f52] text-navy"
                        alt="image"
                      />{" "}
                    </div>
                    <h4 className="text-[1rem]">
                      Accurate Data Analysis and Insights
                    </h4>
                  </div>
                  <div className="w-[10%] flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full">
                    <div className="svg-bg svg-bg-lg !bg-[#eaf3ef] !rounded-[0.8rem] mb-4">
                      {" "}
                      <img
                        src="assets/img/icons/solid/checked.svg"
                        className="svg-inject icon-svg solid text-[#343f52] text-navy"
                        alt="image"
                      />{" "}
                    </div>
                    <h4 className="text-[1rem]">
                      Enhanced Workflow Automation
                    </h4>
                  </div>
                </div>
              </marquee>
            </div>
          </section>
          <div class="blog itemgrid grid-view container pt-20">
            <div class="flex flex-wrap mx-[-15px] isotope xl:mx-[-20px] lg:mx-[-20px] md:mx-[-20px] mt-[-40px] !mb-8">
              <div class="flex flex-wrap mx-[-15px]">
                <div class="lg:w-9/12 xl:w-8/12 xxl:w-7/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto">
                  <h2 class="!text-[.75rem] !leading-[1.35] uppercase text-[#3f78e0]  !text-center">
                    In under
                  </h2>
                  <h3 class="text-[calc(1.305rem_+_0.66vw)] font-bold xl:text-[1.8rem] !leading-[1.3] !mb-6 !text-center">
                    Think unique and be innovative. Make a difference With ECHS
                    CELL{" "}
                  </h3>
                </div>
              </div>
              <article class="item post xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] xl:px-[20px] lg:px-[20px] md:px-[20px] mt-[40px] px-[15px] max-w-full">
                <div class="card content-section custom-card-size">
                  <figure class="card-img-top overlay overlay-1 hover-scale group">
                    <a href="#">
                      {" "}
                      <img
                        class="!transition-all !duration-[0.35s] !ease-in-out group-hover:scale-105"
                        src={card1}
                        alt="image"
                      />
                    </a>
                  </figure>
                  <div class="card-body flex-[1_1_auto] p-[40px] xl:p-[1.75rem_1.75rem_1rem_1.75rem] lg:p-[1.75rem_1.75rem_1rem_1.75rem] md:p-[1.75rem_1.75rem_1rem_1.75rem] sm:pb-4 xsm:pb-4  ">
                    <div class="post-header !mb-[.9rem]">
                      <div class="inline-flex mb-[.4rem] uppercase tracking-[0.02rem] text-[0.7rem] font-bold text-[#aab0bc] relative align-top pl-[1.4rem] before:content-[''] before:absolute before:inline-block before:translate-y-[-60%] before:w-3 before:h-[0.05rem] before:left-0 before:top-2/4 before:bg-[#3f78e0]">
                        <a /* href="#" */ class="hover" rel="category">
                          Adm Comdt
                        </a>
                      </div>
                      <h2 class="post-title h3 !mt-1 !mb-3">
                        <a
                          class="text-[#343f52] hover:text-[#3f78e0]"
                          /* href="" */
                        >
                          Brig Salil M.P
                        </a>
                      </h2>
                    </div>
                  </div>
                </div>
              </article>
              <article class="item post xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] xl:px-[20px] lg:px-[20px] md:px-[20px] mt-[40px] px-[15px] max-w-full">
                <div class="card content-section custom-card-size">
                  <figure class="card-img-top overlay overlay-1 hover-scale group">
                    <a href="#">
                      {" "}
                      <img
                        class="!transition-all !duration-[0.35s] !ease-in-out group-hover:scale-105"
                        src={card2}
                        alt="image"
                      />
                    </a>
                  </figure>
                  <div class="card-body flex-[1_1_auto] p-[40px] xl:p-[1.75rem_1.75rem_1rem_1.75rem] lg:p-[1.75rem_1.75rem_1rem_1.75rem] md:p-[1.75rem_1.75rem_1rem_1.75rem] sm:pb-4 xsm:pb-4  ">
                    <div class="post-header !mb-[.9rem]">
                      <div class="inline-flex mb-[.4rem] uppercase tracking-[0.02rem] text-[0.7rem] font-bold text-[#aab0bc] relative align-top pl-[1.4rem] before:content-[''] before:absolute before:inline-block before:translate-y-[-60%] before:w-3 before:h-[0.05rem] before:left-0 before:top-2/4 before:bg-[#3f78e0]">
                        <a /* href="#"  */ class="hover" rel="category">
                          Station Commander
                        </a>
                      </div>
                      <h2 class="post-title h3 !mt-1 !mb-3">
                        <a
                          class="text-[#343f52] hover:text-[#3f78e0]" /* href="#" */
                        >
                          Lt Col Apurva Priyadarshi
                        </a>
                      </h2>
                    </div>
                  </div>
                </div>
              </article>
              <article class="item post xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] xl:px-[20px] lg:px-[20px] md:px-[20px] mt-[40px] px-[15px] max-w-full">
                <div class="card content-section custom-card-size">
                  <figure class="card-img-top overlay overlay-1 hover-scale group">
                    <a href="#">
                      {" "}
                      <img
                        class="!transition-all !duration-[0.35s] !ease-in-out group-hover:scale-105"
                        src={card3}
                        alt="image"
                      />
                    </a>
                  </figure>
                  <div class="card-body flex-[1_1_auto] p-[40px] xl:p-[1.75rem_1.75rem_1rem_1.75rem] lg:p-[1.75rem_1.75rem_1rem_1.75rem] md:p-[1.75rem_1.75rem_1rem_1.75rem] sm:pb-4 xsm:pb-4  ">
                    <div class="post-header !mb-[.9rem]">
                      <div class="inline-flex mb-[.4rem] uppercase tracking-[0.02rem] text-[0.7rem] font-bold text-[#aab0bc] relative align-top pl-[1.4rem] before:content-[''] before:absolute before:inline-block before:translate-y-[-60%] before:w-3 before:h-[0.05rem] before:left-0 before:top-2/4 before:bg-[#3f78e0]">
                        <a /* href="#"  */ class="hover" rel="category">
                          Officer-In-Charge ECHS
                        </a>
                      </div>
                      <h2 class="post-title h3 !mt-1 !mb-3">
                        <a
                          class="text-[#343f52] hover:text-[#3f78e0]"
                          /* href="" */
                        >
                          Lt Col G Gopa Kumar
                        </a>
                      </h2>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>

        <div className="progress-wrap fixed w-[2.3rem] h-[2.3rem] cursor-pointer block shadow-[inset_0_0_0_0.1rem_rgba(128,130,134,0.25)] z-[1010] opacity-0 invisible translate-y-3 transition-all duration-[0.2s] ease-[linear,margin-right] delay-[0s] rounded-[100%] right-6 bottom-6 motion-reduce:transition-none after:absolute after:content-['\e951'] after:text-center after:leading-[2.3rem] after:text-[1.2rem] after:text-[#605dba] after:h-[2.3rem] after:w-[2.3rem] after:cursor-pointer after:block after:z-[1] after:transition-all after:duration-[0.2s] after:ease-linear after:left-0 after:top-0 motion-reduce:after:transition-none after:font-Unicons">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              className="fill-none stroke-[#605dba] stroke-[4] box-border transition-all duration-[0.2s] ease-linear motion-reduce:transition-none"
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            />
          </svg>
        </div>
      </>
    </React.Fragment>
  );
}
